import type { RoiFilterStep, RoiFilterStrategyContext } from './roi-filter.types';

export function applyRoiIdInFilter(step: RoiFilterStep, ctx: RoiFilterStrategyContext): Set<string> | undefined {
  const ids = parseRoiIdList(step.value);
  if (ids === undefined) return undefined;

  const snapshot = new Set(ids);
  const filteredRoiIds = Array.from(ctx.previousRoiIds).filter((id) => snapshot.has(id));
  return new Set(filteredRoiIds);
}

function parseRoiIdList(value: string): string[] | undefined {
  try {
    const parsed = JSON.parse(value);
    if (!Array.isArray(parsed)) return undefined;
    return parsed.filter((v): v is string => typeof v === 'string');
  } catch {
    return undefined;
  }
}
